import {FormattedMessage} from "react-intl"

export const CERTIFICATE_STATUSES = {
    0: "NOT_ASSIGNED",
    1: "ASSIGNED",
    2: "GENERATED",
    3: "REVOKED",
    4: "REFUND_INITIATED",
    5: "REFUND_CONFIRMED",
    6: "REFUND_SUCCESS",
    7: "EXPIRED",
    8: "ACTIVATING_IN_PROGRESS"
}

export const CERTIFICATE_STATUSES_MESSAGES = {
    [CERTIFICATE_STATUSES[0]]: <FormattedMessage id="certificate_statuses.not_assigned" />,
    [CERTIFICATE_STATUSES[1]]: <FormattedMessage id="certificate_statuses.assigned" />,
    [CERTIFICATE_STATUSES[2]]: <FormattedMessage id="certificate_statuses.generated" />,
    [CERTIFICATE_STATUSES[3]]: <FormattedMessage id="certificate_statuses.revoked" />,
    [CERTIFICATE_STATUSES[4]]: <FormattedMessage id="certificate_statuses.refund_initiated" />,
    [CERTIFICATE_STATUSES[5]]: <FormattedMessage id="certificate_statuses.refund_confirmed" />,
    [CERTIFICATE_STATUSES[6]]: <FormattedMessage id="certificate_statuses.refund_success" />,
    [CERTIFICATE_STATUSES[7]]: <FormattedMessage id="certificate_statuses.expired" />,
    [CERTIFICATE_STATUSES[8]]: <FormattedMessage id="certificate_statuses.assigned" />,
}

export const CERTIFICATE_STATUS_CODES = {
    NOT_ASSIGNED: 0,
    ASSIGNED: 1,
    GENERATED: 2,
    REVOKED: 3,
    REFUND_INITIATED: 4,
    REFUND_CONFIRMED: 5,
    REFUND_SUCCESS: 6,
    EXPIRED: 7,
    ACTIVATING_IN_PROGRESS: 8,
}

const CERTIFICATE_FILTER_EQUIVALENT_STATUSES = {
    [CERTIFICATE_STATUS_CODES.ASSIGNED]: [
        CERTIFICATE_STATUS_CODES.ASSIGNED,
        CERTIFICATE_STATUS_CODES.ACTIVATING_IN_PROGRESS,
    ],
}

export const getCertificateStatusFilterIdentifiers = (statuses = []) => {
    return statuses.reduce((identifiers, item) => {
        const statusIdentifiers = CERTIFICATE_FILTER_EQUIVALENT_STATUSES[item.identifier] || [item.identifier];

        return identifiers.concat(statusIdentifiers);
    }, []);
}

export const FILTERS = {
    'statuses': 'statuses',
  };

  export const FILTERS_NAMES = {
    'statuses': 'Status',
    'byOrder': {
      ro: 'Comanda',
      en: 'Order'
    }
  };
